import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Extra } from './types';

type Variables = {
  id: number;
  endTime: string;
};
export type CreateExtensionIntent = {
  data: {
    endTime: string;
    numDaysAdded?: number;
    numHoursAdded?: number;
    dailyRate?: number;
    weeklyDiscount?: number;
    monthlyDiscount?: number;
    insuranceDailyRate?: number;
    recurringExtras?: Extra[];
    outstandingBalance?: number;
    subtotal?: number;
    stripeSecret?: string;
    reservationId?: number;
    ephemeralKey?: string;
    customerSessionSecret?: string;
    stripeCustomerId?: string;
  };
};

export const useCreateExtensionIntent = createMutation<
  CreateExtensionIntent,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/extension-intent`,
      method: 'POST',
      data: {
        end_time: variables.endTime,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
